// TODO: schema is still in the form component, need to move i18n.

export enum DualCtaVariant {
  FullWidth = 'full_width',
  MediumWidth = 'medium_width',
}
